import { render, staticRenderFns } from "./ServerDnsHover.vue?vue&type=template&id=5b64cfa8&scoped=true&"
import script from "./ServerDnsHover.vue?vue&type=script&lang=ts&"
export * from "./ServerDnsHover.vue?vue&type=script&lang=ts&"
import style0 from "./ServerDnsHover.vue?vue&type=style&index=0&id=5b64cfa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64cfa8",
  null
  
)

export default component.exports